module.exports = __webpack_public_path__ + "static/media/covi_per_han_wip.19a6b474.png";